var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppAvatarPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 4,
    fill: "#FAF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.828 19.828a1 1 0 00-1 1v5.219a1 1 0 001 1h5.219a1 1 0 001-1v-5.219a1 1 0 00-1-1h-5.219zm-.015-1.64a2.625 2.625 0 00-2.625 2.625v5.25a2.625 2.625 0 002.625 2.625h5.25a2.625 2.625 0 002.625-2.625v-5.25a2.625 2.625 0 00-2.625-2.625h-5.25zm.015 14.765a1 1 0 00-1 1v5.219a1 1 0 001 1h5.219a1 1 0 001-1v-5.219a1 1 0 00-1-1h-5.219zm-.015-1.64a2.625 2.625 0 00-2.625 2.625v5.25a2.625 2.625 0 002.625 2.624h5.25a2.625 2.625 0 002.625-2.624v-5.25a2.625 2.625 0 00-2.625-2.626h-5.25zm12.14-10.485a1 1 0 011-1h5.219a1 1 0 011 1v5.219a1 1 0 01-1 1h-5.219a1 1 0 01-1-1v-5.219zm-1.64-.015a2.625 2.625 0 012.625-2.625h5.25a2.625 2.625 0 012.624 2.625v5.25a2.625 2.625 0 01-2.624 2.625h-5.25a2.625 2.625 0 01-2.626-2.625v-5.25zm2.64 12.14a1 1 0 00-1 1v5.219a1 1 0 001 1h5.219a1 1 0 001-1v-5.219a1 1 0 00-1-1h-5.219zm-.016-1.64a2.625 2.625 0 00-2.624 2.625v5.25a2.625 2.625 0 002.625 2.624h5.25a2.625 2.625 0 002.624-2.624v-5.25a2.625 2.625 0 00-2.624-2.626h-5.25z",
    fill: "#6B46C1"
  })));
}

export default __webpack_public_path__ + "static/media/appAvatarPlaceholder.5d68493b.svg";
export { SvgAppAvatarPlaceholder as ReactComponent };